<template>
	<g :style="{
		transformOrigin: `${radius}px ${radius}px`,
		transform: `rotate(${index * arcLength}deg)`,
	}">
		<svg :viewBox="`0 0 ${cx2} ${radius}`" :width="cx2" :height="radius" :x="radius" y="0">
			<path :d="path" :fill="fill" class="slice" />
			<path d="M0 0 0 250" fill="none" stroke-width="4" stroke="url(#border)" />
			<g :style="{
				transformOrigin: `0 ${radius}px`,
				transform: `rotate(${arcLength / 2}deg)`,
			}">
				<use :xlink:href="`#${symbol}`" :x="iconX" y="20" :width="iconWidth" :fill="iconFill" />
			</g>
		</svg>
	</g>
</template>

<script>
const DEGREE_TO_RADIANS = Math.PI / 180;

export default {
	name: 'SVGWheelSlice',
	props: {
		index: {
			type: Number,
			required: true,
		},
		arcLength: {
			type: Number,
			required: true,
		},
		radius: {
			type: Number,
			required: true,
		},
		symbol: {
			type: [String, Number],
			required: true,
		},
		fill: {
			type: String,
			required: true,
		},
		iconFill: {
			type: String,
			required: true,
		},
	},
	computed: {
		cx2() {
			return (Math.sin(DEGREE_TO_RADIANS * this.arcLength) * this.radius);
		},
		cy2() {
			return (-Math.cos(DEGREE_TO_RADIANS * this.arcLength) * this.radius) + this.radius;
		},
		iconWidth() {
			return this.cx2 / 2;
		},
		iconX() {
			return -(this.iconWidth / 2);
		},
		path() {
			return `M0 ${this.radius} 0 0 A${this.radius} ${this.radius} 0 0 1 ${this.cx2} ${this.cy2}Z`;
		},
	},
};
</script>
